var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary p-2 text-dark ml-2 px-3 py-2 rounded",attrs:{"type":"button","title":_vm.buttonText},on:{"click":function($event){return _vm.doSomething()}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }